import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    mediaObjects: {
        currentSliderObj: 0,
        lg: 'de',
        mediaActions: { showOverlay: false },
        fsSettings: 1,
        currentNav: 'home',
        viewMode: 'home',
        totalPages: 1,
        currentPage: 1,
        workCurrentPage: 1,
        keyword: '',
        laneTree: [],
        loading: false,
        homeObj: {
            autoplay: true,
            loop: true,
            trailerStart: true
        },
        searchFilterObj: {},
        workFilterObj: {},
        hasMediaRights: false
    }
}

const MediaReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.MEDIA_UPDATE_MEDIAOBJECTS:
            return {
                loading: true
            }
        case actionTypes.MEDIA_UPDATE_MEDIAOBJECTS_SUCCESS:
            return {
                loading: false,
                mediaObjects: { ...state.mediaObjects, ...action.payload }
            }
        default:
            return state;
    }
}

export default MediaReducer;